import { useState, useRef } from 'react'

import { Camera01Icon, CancelCircleHalfDotIcon } from '@hugeicons/react'
import { motion } from 'framer-motion'
import { useOnClickOutside } from 'usehooks-ts'

import { useNavigation } from '@/shared/hooks/useNavigation'
import { createModuleIcon } from '@/shared/ui/ModuleIcon'


import { BottomNavItem, BottomNavItemContent } from './NavItem'
import { BottomNavItemSkeleton } from './NavItemSkeleton'
import { BottomNavQrCodeReader } from './QrCodeReader'
import styles from './styles.module.scss'
import { useAppMenu } from '../../menu'

export const LayoutBottomNav = () => {
  const menuRef = useRef(null)
  const { sidebarNavItems, itemsKnown } = useNavigation()
  const { isOpen: appMenuIsOpen, toggle: toggleAppMenu } = useAppMenu()
  const [menuIsActive, setMenuIsActive] = useState(false)

  const closeQrMenu = (props = {}) => {
    const { callback } = props
    menuIsActive && setMenuIsActive(false)

    callback && callback()
  }

  useOnClickOutside(menuRef, closeQrMenu)

  // Itens reais quando os destinos são conhecidos, esqueleto quando não.
  // Nunca módulo padrão como preenchimento.
  const dynamicItem = index =>
    itemsKnown && sidebarNavItems[index]
      ? sidebarNavItems[index]
      : {
          slug: `nav-skeleton-${index}`,
          component: BottomNavItemSkeleton
        }

  const navItems = [
    dynamicItem(0),
    dynamicItem(1),
    {
      slug: 'qr-code-scanner',
      icon: Camera01Icon,
      name: '',
      component: ({ icon }) => {
        const Icon = icon

        const onOpenQrCodeReader = () => {
          if (!menuIsActive) {
            setMenuIsActive('qr-code')
          } else closeQrMenu()
        }

        return (
          <motion.button
            onClick={onOpenQrCodeReader}
            className={`flex shrink-0 flex-col items-center justify-center rounded-full ${styles.BottomNavItemQrCodeScanner}`}
            whileTap={{ scale: 0.94 }}
            transition={{ type: 'spring', stiffness: 600, damping: 30 }}
          >
            <Icon className="text-white" variant="stroke" size={24} />
          </motion.button>
        )
      }
    },
    dynamicItem(2),
    {
      slug: 'menu',
      icon: createModuleIcon('modules'),
      name: 'Mais',
      component: ({ icon, name }) => {
        const active = appMenuIsOpen
        const Icon = active ? CancelCircleHalfDotIcon : icon
        const firstName = name.split(' ')[0]

        return (
          <button
            onClick={() => toggleAppMenu({ source: 'more' })}
            className={styles.BottomNavItemLink}
          >
            {active ? (
              <span className={styles.BottomNavItemActiveBar} aria-hidden="true" />
            ) : null}
            <BottomNavItemContent
              icon={Icon}
              name={name}
              active={active}
              label={active ? 'Fechar' : firstName}
            />
          </button>
        )
      }
    }
  ]

  return (
    <div className={styles.BottomNavWrapper}>
      <div
        ref={menuRef}
        className={`${styles.BottomNavMenu} ${
          menuIsActive ? styles.BottomNavMenuActive : ''
        }`}
      >
        {menuIsActive == 'qr-code' && (
          <BottomNavQrCodeReader onHide={closeQrMenu} />
        )}
      </div>
      <div className={styles.BottomNav}>
        <div className={styles.BottomNavInner}>
          {navItems.map(navItem => (
            <BottomNavItem key={navItem.slug} {...navItem} />
          ))}
        </div>
      </div>
      <div className={styles.BottomNavBackDrop} />
    </div>
  )
}
